import BancMesureSection, { LONGUEUR_BANC_CONFIG } from "./BancMesureSection";



export default function LongueurBancSection(props) {

  return <BancMesureSection config={LONGUEUR_BANC_CONFIG} {...props} />;

}

